import { config } from 'config';
import { HeaderBackground } from 'app/components/HeaderBar/HeaderBackground';
import {
  getPaddingLeft,
  getPaddingRight,
} from 'app/components/HeaderBar/utils';
import { useAppSelector } from 'app/store';
import { getAppInfo } from 'app/store/Electron/selectors';
import { useIsMobile } from 'app/utils/hooks';
import { HeaderLogo } from 'app/components/HeaderBar/HeaderLogo';
import { NavControls } from 'app/components/HeaderBar/NavControls';
import { Button, Flex, useMediaQuery } from '@chakra-ui/react';
import { HelpLink } from 'app/components/HeaderBar/HelpLink';
import { routes } from 'app/routing/routesConfig';
import { useNavigate } from 'react-router-dom';
import qs from 'query-string';
import { SystemStyleObject } from '@chakra-ui/styled-system';

interface SharedAudioHeaderBarProps {
  referralId?: string;
  sx?: SystemStyleObject;
}

export const SharedAudioHeaderBar = ({
  referralId,
  sx,
}: SharedAudioHeaderBarProps) => {
  const isWeb = !config.isElectronBuild;

  const platform = useAppSelector(getAppInfo)?.platform;
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [helpLinkBreakpoint] = useMediaQuery('(min-width: 550px)');
  const [logoBreakpoint] = useMediaQuery('(max-width: 350px)');

  return (
    <HeaderBackground
      justifyContent="space-between"
      paddingLeft={getPaddingLeft(platform)}
      paddingRight={getPaddingRight(isWeb, platform)}
      isSignedOutWeb
      pr={isMobile ? 4 : 12}
      boxSizing="border-box"
      sx={sx}
    >
      {isWeb ? (
        <HeaderLogo
          options={{
            isSignedOutWeb: true,
            isInPublicRoute: true,
            showShortLogo: logoBreakpoint,
            showFullLogo: true,
          }}
        />
      ) : (
        <NavControls platform={platform} />
      )}
      <Flex gap={6}>
        {!isMobile && helpLinkBreakpoint && <HelpLink />}
        <Button
          size="md"
          onClick={() => {
            const query = qs.stringify({ referralId });
            navigate(`${routes.signUp.path}?${query}`);
          }}
        >
          Create Account
        </Button>
      </Flex>
    </HeaderBackground>
  );
};
